module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fragment', [(_vm.brand) ? _c('BrandForm', {
    attrs: {
      "parent-loading": _vm.loading,
      "type": _vm.FORM_TYPE.edit,
      "brand": _vm.brand
    },
    on: {
      "cancel": _vm.cancel,
      "save": _vm.saveEditBrand
    }
  }) : (_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e072a7b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/brand/EditBrand.vue
// module id = 3062
// module chunks = 0